export default function ResetIcon({ className = '', onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M6.5 1.25a4.75 4.75 0 1 1-3.35 8.1"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1.75 5.2L3.9 3.05M1.75 5.2h2.15V3.05"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}